import { FC } from 'react'

type ResetIconProp = {
  color: string
}

const ResetIcon: FC<ResetIconProp> = ({ color }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 8.20001C14 11.5137 11.3137 14.2 8 14.2C4.68629 14.2 2 11.5137 2 8.20001C2 4.8863 4.68629 2.20001 8 2.20001C9.61022 2.20001 11.0723 2.83431 12.15 3.86668"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 2.20001V5.20001H11.5H10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ResetIcon
